<script>
import { mapActions, mapGetters } from "vuex";
import MetisMenu from "metismenujs/dist/metismenujs";
import { sideNavbarMenu } from "./menu";
import ReactiveUser from "./reactiveUser/ReactiveUser";

export default {
  components: { ReactiveUser },
  data() {
    return {
      sideNavbarMenu,
      currentUserRole: "",
      currentUserPermissions: {},
      sideNavbarMenuWithSubItems: [],
    };
  },
  watch: {
    getPassportData(data) {
      if (data && !data.active) {
        this.$bvModal.show("reactivePassportAccount");
      }
    },
  },
  mounted() {
    const isStandAlone =
      this.$store.getters["authfack/currentEntity"].package == "Standalone";
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu("#side-menu");

    let currentItem;

    sideNavbarMenu.forEach((item) => {
      let childItem;
      childItem = item.subItems?.find(
        (subItem) => subItem.link == window.location.pathname
      );

      if (childItem) currentItem = childItem;
      else if (item.link == window.location.pathname) currentItem = item;
    });

    if (!currentItem) {
      let currentRoute = window.location.pathname;
      currentRoute = currentRoute.split("/");
      const isSSO = currentRoute.some((path) => path == "sso");
      const isJourney = currentRoute.some(
        (path) => path == "journey" || path == "add-journey"
      );
      const isAnnouncement = currentRoute.some(
        (path) => path == "announcements" || path == "add-announcement"
      );
      const isCompliance = currentRoute.some(
        (path) => path == "compliances" || path == "compliance-new"
      );

      if (isJourney) currentItem = sideNavbarMenu.find((item) => item.id == 10);
      else if (isAnnouncement)
        currentItem = sideNavbarMenu.find((item) => item.id == 6);
      else if (isCompliance)
        currentItem = this.c.find((item) => item.id == 11);
      else if (isSSO) {
        currentItem = sideNavbarMenu.find(
          (item) => item.id == (isStandAlone ? 7 : 2)
        );
      }
    }
  },
  computed: {
    ...mapGetters("authfack", [
      "currentEntity",
      "getUserPermissions",
      "getUserRole",
      "userDetails",
    ]),
    ...mapGetters("passport", ["getPassportData"]),
    packageType() {
      return this.currentEntity.package;
    },
    isLtTechteam() {
      return this.userDetails.email == "lt_techteam@visipoint.com";
    },
    currentActiveParentItem() {
      // Check if sideNavbarMenu exists and is an array
      if (!Array.isArray(sideNavbarMenu)) {
        console.error("sideNavbarMenu must be an array");
        return null;
      }

      // Find the active item based on the current route path
      const currentActiveItem = sideNavbarMenu.find((item) => {
        // Check if the item itself matches the current route
        if (item.link === this.$route.path) {
          return true;
        }

        if (item.link && item.link == this.$route.meta.parentRoutePath) {
          return true;
        }

        // If not, check if any of its subItems match the current route
        if (item.subItems && Array.isArray(item.subItems)) {
          return item.subItems.some((subitem) => {
            return subitem.link === this.$route.path || subitem.link === this.$route.meta?.parentRoutePath ;
          });
        }

        //return false if not found on any parent items or subitems
        return false;
      });

      // Return the link of the found active item, or null if none was found
      return currentActiveItem ? currentActiveItem : null;
    },
  },
  methods: {
    ...mapActions("passport", ["checkPassportStatus", "resetState"]),
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
    onBackToPassport() {
      this.resetState();
      const passportId =
        JSON.parse(localStorage.getItem("userDetails")) &&
        JSON.parse(localStorage.getItem("userDetails")).passport_id;
      this.checkPassportStatus({ id: passportId });
    },
  },

  beforeMount() {
    this.resetState();
    this.currentUserRole = this.getUserRole?.name?.toLowerCase();
    this.currentUserPermissions = this.getUserPermissions;
    this.sideNavbarMenuWithSubItems = sideNavbarMenu.filter(
      (item) => !!item.subItems
    );
  },
};
</script>
<template>
  <div id="sidebar-menu">
    <b-modal id="reactivePassportAccount" hide-footer hide-header size="lg">
      <ReactiveUser />
    </b-modal>
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled" style="padding-top: 0 !important;"
    @mouseover="$emit('setIsHovered', true)" @mouseleave="$emit('setIsHovered', false)">
      <template v-for="item in sideNavbarMenu">
        <!-- Title <Ex. SYSTEM> -->
        <li
          class="menu-title"
          v-if="item.isTitle && currentUserRole == 'system admin'"
          :key="item.id"
        >
          {{ $t(item.label) }}
        </li>

        <li
          :class="{
            'disabled-list-item':
              (packageType == 'Standalone' &&
                $t(item.label) != $t('sideNavbarMenu.sites.text') &&
                $t(item.label) != $t('sideNavbarMenu.passport.text') &&
                ($t(item.label) != $t('sideNavbarMenu.company.text') ||
                  ($t(item.label) == $t('sideNavbarMenu.company.text') && !isLtTechteam))) ||
              !packageType,
            'mm-active active-list-item':
              currentActiveParentItem &&
              currentActiveParentItem.link == item.link,
            'reporting': item.id == 8,
            'user-settings': item.id == 9
          }"
          v-if="
            (!item.isTitle &&
              !item.isLayout &&
              currentUserPermissions[item.acl_name] &&
              currentUserPermissions[item.acl_name].pivot &&
              currentUserPermissions[item.acl_name].pivot.allowed == 1) ||
            item.acl_name === 'passport'
          "
          :key="item.id"
        >
          <a
            v-if="hasItems(item)"
            href="javascript:void(0);"
            class="is-parent"
            :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }"
          >
            <span class="svg-icon-mod" v-html="item.svg"></span>
            <!-- Side nav list with sub nav list (Ex. reporting)-->
            <span>
              {{ $t(item.label) }}
            </span>
            <span
              :class="`badge badge-pill badge-${item.badge.variant} float-right`"
              v-if="item.badge"
              >{{ $t(item.badge.text) }}</span
            >
          </a>
          <router-link
            :to="item.link"
            v-if="!hasItems(item)"
            class="side-nav-link-ref"
            :target="item.newTab ? '_blank' : ''"
          >
            <!-- <i
              @click="
                $t(item.label) == $t('sideNavbarMenu.passport.text') && onBackToPassport()
              "
              :class="`bx ${item.icon}`"
              v-if="item.icon"
            ></i> -->
            <div>
              <p
                class="svg-icon-mod"
                v-html="item.svg"
                @click="
                  $t(item.label) == $t('sideNavbarMenu.passport.text') && onBackToPassport()
                "
              ></p>

              <!-- Side nav list with no sub list (Ex. Users)-->
              <span
                class="side-menu-label"
                @click="
                  $t(item.label) == $t('sideNavbarMenu.passport.text') && onBackToPassport()
                "
              >
                {{ $t(item.label) }}
              </span>
              <span
                @click="
                  $t(item.label) == $t('sideNavbarMenu.passport.text') && onBackToPassport()
                "
                :class="`badge badge-pill badge-${item.badge.variant} float-right`"
                v-if="item.badge"
                >{{ $t(item.badge.text) }}</span
              >
            </div>
          </router-link>

          <ul
            v-if="hasItems(item)"
            class="sub-menu"
            :class="
              currentActiveParentItem &&
              currentActiveParentItem.link == item.link
                ? 'mm-show'
                : 'mm-collapse'
            "
            aria-expanded="true"
          >
            <!-- level 2 - sub list (Ex. Reporting)-->
            <li v-for="(subitem, index) of item.subItems" :key="index">
            <hr v-if="index == 0" class="sub-menu-hr">
              <router-link
                :to="subitem.link"
                v-if="
                  !hasItems(subitem) &&
                  currentUserPermissions[subitem.acl_name] &&
                  currentUserPermissions[subitem.acl_name].pivot &&
                  currentUserPermissions[subitem.acl_name].pivot.allowed == 1
                "
                class="side-nav-link-ref"
              >
                <p
                  class="sub-side-menu-label"
                  :class="{
                    'active-sub-item': subitem.link == $route.path || subitem.link == $route.meta.parentRoutePath,
                  }"
                >
                  {{ $t(subitem.label) }}
                </p>
              </router-link>
              <a
                v-if="hasItems(subitem)"
                class="side-nav-link-a-ref has-arrow"
                href="javascript:void(0);"
                >{{ $t(subitem.label) }}</a
              >
              <!-- 3rd sub level -->
              <!-- <ul
                v-if="hasItems(subitem)"
                class="sub-menu mm-collapse"
                aria-expanded="false"
              >
                <li
                  v-for="(subSubitem, index) of subitem.subItems"
                  :key="index"
                >
                  <router-link
                    :to="subSubitem.link"
                    class="side-nav-link-ref"
                    >{{ $t(subSubitem.label) }}</router-link
                  >
                </li>
              </ul> -->
            </li>
          </ul>
        </li>
      </template>
    </ul>
  </div>
</template>
<style lang="scss">
.menu-colored {
  background: #103F5EE0 !important;
  #sidebar-menu ul li a, .active-list-item .has-arrow:after, .active-list-item span, .active-list-item .active-sub-item, .company-name {
    color: white !important;
  }
  #sidebar-menu ul li a .suchicon, #sidebar-menu ul li a .suchicon path, .header-item-side svg path {
    fill: white !important;
  }
  .active-list-item svg > path {
    fill: white !important;
  }
}
.side-nav-link-ref div {
  height: 24px;
  display: flex;
  align-items: center;
}
.menu-list-item {
  color: #103f5e;
  font-weight: 700;
  svg {
    fill: #103f5e !important;
  }
}
div#company-tooltip.tooltip {
  padding: 19px 14px !important;
  opacity: 1 !important;
  inset-inline-start: -8px !important;
}
div#company-tooltip .tooltip-inner {
  max-width: 600px !important;
  position: relative !important;
  font-size: 12px;
  color: #787878;
  width: 206px;
  min-height: 41px;
  inset-inline-start: -17px;
  top: 0;
  background: #FFFFFF;
  box-shadow: 1px 1px 4.4px rgba(0, 0, 0, 0.261);
  border-radius: 6px;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

#sidebar-menu {
  svg {
    width: 100%;
  }

  span {
    font-size: 14px !important;
    line-height: 22px !important;
    letter-spacing: 0.5px !important;
    // font-weight: 500;
    height: 24px;
    display: flex;
    align-items: center;
  }
}
.bs-tooltip-bottom .arrow::before {
  border-bottom-color: transparent;
}

.metismenu {
  padding-top: 12px !important;
}
.svg-icon-mod,
.side-menu-label,
.sub-side-menu-label {
  display: inline-block;
  margin: 0;
  padding: 0;
}
.svg-icon-mod {
  margin-inline-end: 16px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.active-list-item {
  span,
  .active-sub-item {
    color: #103f5e;
    font-weight: 700;
  }
  svg > path {
    fill: #103f5e;
  }
  .has-arrow:after {
    color: #103f5e;
  }
}
</style>
